export default __webpack_public_path__ + "static/media/play-icon.23793df2.svg";